import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { FeatureForm, FeatureFormData } from "../form/FeatureForm";
import { useFeatureToast, useFeatureRegistration } from "../../pages/features/hook";
import { Toast } from "../../atoms/Toast";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: FeatureFormData) => void;
  refetchFeatures?: () => void;
};

export const CreateFeatureModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  refetchFeatures
}) => {
  const { toast, showToast, hideToast } = useFeatureToast();
  const { handleRegisterFeature } = useFeatureRegistration(showToast, refetchFeatures);

  const handleFormSubmit = (data: FeatureFormData, onError: (message: string) => void) => {
    handleRegisterFeature(
      data,
      onError,
      () => {
        onSubmit?.(data);
        onClose(); // Close modal on successful submission
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Create Feature"
        onClose={onClose}
      >
        <FeatureForm key={isOpen ? 'open' : 'closed'} handleSubmit={handleFormSubmit} />
      </ModalTemplate>
    </div>
  );
};
